import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as qs from "query-string";
import { BackendAPIs, getBaseApi, postCall } from "../../constants";
import { Helmet } from "react-helmet";
import "./AmazonAdvertisingCallback.css";

class AmazonAdvertisingCallback extends Component {
  constructor(props) {
    super(props);
    
    // Extract code and scope from URL parameters
    const { code, scope } = qs.parse(props.location.search);
    
    this.state = {
      code,
      scope,
      loading: true,
      success: false,
      error: null,
      message: ""
    };
  }

  componentDidMount() {
    // Automatically send the callback data to backend when component mounts
    this.handleCallback();
  }

  handleCallback = () => {
    const { code, scope } = this.state;
    
    if (!code || !scope) {
      this.setState({
        loading: false,
        error: true,
        message: "Missing required parameters (code or scope) in the callback URL."
      });
      return;
    }

    // Send code and scope to backend
    postCall(
      getBaseApi() + BackendAPIs.advertisingamazon,
      {
        accName: localStorage.getItem('accName'),
        code,
        scope
      },
      false,
      null,
      true // ignoreException
    ).then(
      (resp) => {
        // Check if backend returned hasError flag
        if (resp.hasError) {
          this.setState({
            loading: false,
            error: true,
            message: resp.message || "There was an issue with the Amazon advertising integration."
          });
        } else {
          this.setState({
            loading: false,
            success: true,
            message: resp.message || "Amazon advertising integration completed successfully!"
          });
        }
      },
      (err) => {
        let message = "Something went wrong while processing the Amazon advertising callback.";
        if (err.responseJSON && err.responseJSON.message) {
          message = err.responseJSON.message;
        }
        this.setState({
          loading: false,
          error: true,
          message
        });
      }
    );
  };

  navigateToHome = () => {
    this.props.history.push("/");
  };

  render() {
    const { loading, success, error, message } = this.state;

    return (
      <div className="amazon-callback-page">
        <Helmet>
          <title>Visual COGS | Amazon Advertising Integration</title>
          <meta
            name="description"
            content="Processing Amazon advertising integration callback"
          />
        </Helmet>
        <div className="amazon-callback-container">
          <div className="amazon-callback-wrapper">
            <div className="amazon-callback-content">
              <div className="amazon-callback-box">
                {loading && (
                  <div className="amazon-text-center">
                    <div className="amazon-loading-spinner">
                      <div className="amazon-spinner" role="status">
                        <span className="amazon-sr-only">Loading...</span>
                      </div>
                    </div>
                    <div className="amazon-callback-title amazon-title-spacing">
                      Processing Amazon Integration
                    </div>
                    <div className="amazon-callback-subtitle">
                      Please wait while we set up your Amazon advertising integration...
                    </div>
                  </div>
                )}

                {success && (
                  <div className="amazon-text-center">
                    <div className="amazon-success-icon amazon-icon-spacing">
                      <i className="fas fa-check-circle"></i>
                    </div>
                    <div className="amazon-callback-title amazon-success-title amazon-title-spacing">
                      Integration Successful!
                    </div>
                    <div className="amazon-callback-subtitle amazon-subtitle-spacing">
                      {message}
                    </div>
                    <button
                      className="amazon-callback-btn amazon-success-btn"
                      onClick={this.navigateToHome}
                    >
                      Continue to Dashboard
                    </button>
                  </div>
                )}

                {error && (
                  <div className="amazon-text-center">
                    <div className="amazon-error-icon amazon-icon-spacing">
                      <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <div className="amazon-callback-title amazon-error-title amazon-title-spacing">
                      Integration Failed
                    </div>
                    <div className="amazon-callback-subtitle amazon-subtitle-spacing">
                      {message}
                    </div>
                    <button
                      className="amazon-callback-btn amazon-error-btn"
                      onClick={this.navigateToHome}
                    >
                      Return to Home
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AmazonAdvertisingCallback);
